
export function captureRefAndSource({ firstTouch = true } = {}) {
    const url = new URL(window.location.href);
    const ref = url.searchParams.get("ref");
    const source = url.searchParams.get("source");
  
    if (ref) {
      if (!firstTouch || !sessionStorage.getItem("pl_ref")) {
        sessionStorage.setItem("pl_ref", ref);
      }
    }
  
    if (source) {
      if (!firstTouch || !sessionStorage.getItem("pl_source")) {
        sessionStorage.setItem("pl_source", source);
      }
    }
  
    return { ref, source };
  }
  